"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
var Currency;
(function (Currency) {
    let Code;
    (function (Code) {
        Code["USD"] = "USD";
        Code["EUR"] = "EUR";
        Code["GBP"] = "GBP";
        Code["CAD"] = "CAD";
        Code["INR"] = "INR";
        Code["JPY"] = "JPY";
    })(Code = Currency.Code || (Currency.Code = {}));
})(Currency || (exports.Currency = Currency = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3VycmVuY3kuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tbW9uL2N1cnJlbmN5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQWlCLFFBQVEsQ0FTeEI7QUFURCxXQUFpQixRQUFRO0lBQ3JCLElBQVksSUFPWDtJQVBELFdBQVksSUFBSTtRQUNaLG1CQUFXLENBQUE7UUFDWCxtQkFBVyxDQUFBO1FBQ1gsbUJBQVcsQ0FBQTtRQUNYLG1CQUFXLENBQUE7UUFDWCxtQkFBVyxDQUFBO1FBQ1gsbUJBQVcsQ0FBQTtJQUNmLENBQUMsRUFQVyxJQUFJLEdBQUosYUFBSSxLQUFKLGFBQUksUUFPZjtBQUNMLENBQUMsRUFUZ0IsUUFBUSx3QkFBUixRQUFRLFFBU3hCIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IG5hbWVzcGFjZSBDdXJyZW5jeSB7XG4gICAgZXhwb3J0IGVudW0gQ29kZSB7XG4gICAgICAgIFVTRCA9IFwiVVNEXCIsXG4gICAgICAgIEVVUiA9IFwiRVVSXCIsXG4gICAgICAgIEdCUCA9IFwiR0JQXCIsXG4gICAgICAgIENBRCA9IFwiQ0FEXCIsXG4gICAgICAgIElOUiA9IFwiSU5SXCIsXG4gICAgICAgIEpQWSA9IFwiSlBZXCJcbiAgICB9XG59Il19